<script setup>
import {ref} from 'vue'
import {Dialog, DialogPanel, DialogTitle, TransitionRoot} from '@headlessui/vue'
import {useI18n} from 'vue-i18n';

const {t} = useI18n();

const props = defineProps({
  qrCodeBase64: {type: String, required: true},
  bankAccountNumber: {type: String, required: false, default: null},
  variableSymbol: {type: String, required: false, default: null},
});

const isOpen = ref(true)
const emit = defineEmits(['cancel']);
const closeModalWith = () => {
  setTimeout(() => {
    emit('cancel');
    isOpen.value = false;
  }, 300);
}
</script>

<template>
  <TransitionRoot appear :show="isOpen" as="template">
    <Dialog as="div" class="modal show d-block" style="z-index: 1055;">
      <div class="modal-backdrop fade show"></div>
      <div class="modal-dialog modal-dialog-centered" style="z-index: 1055">
        <div class="modal-content">
          <DialogPanel class="modal-body p-4 rounded-lg shadow-lg">
            <div class="modal-header">
              <DialogTitle as="h3" class="modal-title">
                {{ t('paymentQrCodeModal.title') }}
              </DialogTitle>
              <i class="btn-close cursor-pointer" @click="closeModalWith()" aria-label="Close"></i>
            </div>
            <div class="modal-body text-center">
              <img :src="props.qrCodeBase64" alt="qr_code" style="max-width: 100%;">
              <div v-if="props.bankAccountNumber" class="mt-3">{{ t('paymentTerms.bank_account_number') }}: <strong>{{ props.bankAccountNumber }}</strong></div>
              <div v-if="props.variableSymbol">{{ t('paymentTerms.variable_symbol') }}: <strong>{{ props.variableSymbol }}</strong></div>
            </div>
            <div class="modal-footer">
              <button class="btn btn-primary btn-md" @click="closeModalWith()">{{ t('paymentQrCodeModal.close') }}</button>
            </div>
          </DialogPanel>
        </div>
      </div>
    </Dialog>
  </TransitionRoot>
</template>